import React from "react";
import PropTypes from "prop-types";
import { v4 as uuid } from "uuid";

// Components
import { LoaderDots, Empty } from "./loaders";

// Interfaces
import { ITable } from "../interfaces/IUtils";

function table(props: ITable) {
  if (props.isLoading) {
    return <LoaderDots />;
  }
  if (props.results.length === 0) {
    return (
      <Empty
        message={props.emptyMessage || "No hay resultados para mostrar..."}
      />
    );
  }

  const containerExtraClass = props.containerExtraClass || "";
  const tableExtraClass = props.tableExtraClass || "";
  return (
    <div className={`table-responsive ${containerExtraClass}`}>
      <table className={`table ${tableExtraClass}`}>
        <thead>
          <tr>
            {props.headers.map((title) => (
              <th key={uuid()} dangerouslySetInnerHTML={{ __html: title }} />
            ))}
          </tr>
        </thead>
        <tbody>
          {props.results.map((result) => props.getRowFN(result, uuid()))}
        </tbody>
      </table>
    </div>
  );
}

table.propTypes = {
  results: PropTypes.array.isRequired,
  headers: PropTypes.array.isRequired,
  getRowFN: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  emptyMessage: PropTypes.string,
  containerExtraClass: PropTypes.string,
  tableExtraClass: PropTypes.string,
};

export default table;
